


























































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import {GroupIncomingFilterParams} from "@/store/statistics/types";
import {DatePickerWings, FastDateGroupWings, SelectWings, InputWings} from "wings-ui-components";
import {Component, Prop, PropSync, Watch} from "vue-property-decorator";
import {Action, Getter, Mutation} from "vuex-class";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import {beginningOfCurrentDay, currentDate, dateFilter,} from "@/utils/date-util";
import {MsgTransports} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings,
    FastDateGroupWings,
    DatePickerWings,
    InputWings
  },
  filters: { dateFilter },
})
export default class GroupIncomingFilter extends BaseFilter<GroupIncomingFilterParams> {
  @Prop() transport!: MsgTransports;

  @PropSync("show") is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setStaticGroupIncoming') setStatistic: any

  @Getter("incomingGroupBy") groupByList!: string[];
  @Getter("incomingGroupByOptionally") groupByOptionallyListOrig!: string[];

  @Action("getStatisticGroupIncoming") actionGetItems: any;
  @Action("exportStatisticGroupIncoming") actionExport: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("actionLog") actionLog: any;

  VIBER: MsgTransports = MsgTransports.VIBER
  WHATSAPP: MsgTransports = MsgTransports.WHATSAPP

  defaultFilter(): GroupIncomingFilterParams {
    return new GroupIncomingFilterParams(
      beginningOfCurrentDay(),
      currentDate(),
      "day"
    );
  }

  params = { transport: this.transport };
  partnersList: any = [];
  accountsList: any = []
  serviceProvidersList:  any = []

  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "recipient": "service_no",
    "broker_account_login": "broker_account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  storageItemName(): string {
    return `${this.transport}GroupIncomingFilter`;
  }

  async created() {
    this.setStatistic(null)
    this.parseGroupBy()
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction() {
    this.setStatistic(null)
    this.mergeGroupBy();
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics of incoming messages",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems({
        filter: this.filter,
        transport: this.transport,
      });
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  // Override
  async doActionExport() {
    this.mergeGroupBy();
    return await this.actionExport({
      filter: this.filter,
      transport: this.transport,
    });
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }

  @Watch("filter", { immediate: true, deep: true })
  onFilterChanged(newVal: GroupIncomingFilterParams) {
    this.propFilterClone = newVal;
  }

  get groupByOptionallyList() {
    if (this.transport === MsgTransports.SMS) return [...this.groupByOptionallyListOrig, 'operator']
    return this.groupByOptionallyListOrig
  }



}
